import jsPDF from 'jspdf'
import 'jspdf-autotable'

/**
 * Export data to PDF
 */
export function exportToPDF(data, columns, filename, title = 'Report') {
  const doc = new jsPDF()
  
  // Add title
  doc.setFontSize(18)
  doc.text(title, 14, 20)
  
  // Add date
  doc.setFontSize(10)
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 14, 30)
  
  // Prepare table data
  const tableData = data.map((row) =>
    columns.map((col) => {
      const value = col.accessor ? col.accessor(row) : row[col.key]
      return value || ''
    })
  )

  // Add table
  doc.autoTable({
    head: [columns.map((col) => col.label)],
    body: tableData,
    startY: 35,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [14, 165, 233] }, // primary-500
  })

  // Save
  doc.save(`${filename}_${new Date().toISOString().split('T')[0]}.pdf`)
}

/**
 * Export client data to PDF
 */
export function exportClientsToPDF(clients, selectedIds = null) {
  const data = selectedIds
    ? clients.filter((c) => selectedIds.includes(c.id))
    : clients

  const columns = [
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    {
      key: 'date_of_birth',
      label: 'Date of Birth',
      accessor: (row) => row.date_of_birth ? new Date(row.date_of_birth).toLocaleDateString() : '',
    },
    { key: 'gender', label: 'Gender' },
  ]

  exportToPDF(data, columns, 'clients', 'Clients Report')
}

/**
 * Export care plans to PDF
 */
export function exportCarePlansToPDF(plans, selectedIds = null) {
  const data = selectedIds
    ? plans.filter((p) => selectedIds.includes(p.id))
    : plans

  const columns = [
    {
      key: 'client',
      label: 'Client',
      accessor: (row) => row.clients ? `${row.clients.first_name} ${row.clients.last_name}` : '',
    },
    { key: 'title', label: 'Title' },
    { key: 'status', label: 'Status' },
    {
      key: 'start_date',
      label: 'Start Date',
      accessor: (row) => row.start_date ? new Date(row.start_date).toLocaleDateString() : '',
    },
    {
      key: 'end_date',
      label: 'End Date',
      accessor: (row) => row.end_date ? new Date(row.end_date).toLocaleDateString() : '',
    },
  ]

  exportToPDF(data, columns, 'care_plans', 'Care Plans Report')
}

/**
 * Export therapies to PDF
 */
export function exportTherapiesToPDF(therapies, selectedIds = null) {
  const data = selectedIds
    ? therapies.filter((t) => selectedIds.includes(t.id))
    : therapies

  const columns = [
    {
      key: 'client',
      label: 'Client',
      accessor: (row) => row.clients ? `${row.clients.first_name} ${row.clients.last_name}` : '',
    },
    { key: 'name', label: 'Therapy Name' },
    {
      key: 'scheduled_date',
      label: 'Date',
      accessor: (row) => row.scheduled_date ? new Date(row.scheduled_date).toLocaleDateString() : '',
    },
    { key: 'time_of_day', label: 'Time' },
    { key: 'frequency', label: 'Frequency' },
    { key: 'status', label: 'Status' },
  ]

  exportToPDF(data, columns, 'therapies', 'Therapies Schedule')
}

/**
 * Export sessions to PDF
 */
export function exportSessionsToPDF(sessions, selectedIds = null) {
  const data = selectedIds
    ? sessions.filter((s) => selectedIds.includes(s.id))
    : sessions

  const columns = [
    {
      key: 'client',
      label: 'Client',
      accessor: (row) => row.clients ? `${row.clients.first_name} ${row.clients.last_name}` : '',
    },
    {
      key: 'session_date',
      label: 'Date',
      accessor: (row) => row.session_date ? new Date(row.session_date).toLocaleDateString() : '',
    },
    { key: 'duration_minutes', label: 'Duration (min)' },
    { key: 'focus_area', label: 'Focus Area' },
    {
      key: 'outcome_summary',
      label: 'Summary',
      accessor: (row) => row.outcome_summary?.substring(0, 50) || '',
    },
  ]

  exportToPDF(data, columns, 'sessions', 'Sessions Report')
}

